import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import LOGO from "../../assets/images/logo/sevenly-logo-new.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/auth";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useAuth } from "../../context";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import CallIcon from "@mui/icons-material/Call";
import Tooltip from "@mui/material/Tooltip";
import "./topNav.css";
const TopNavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, token, picture } = useSelector((state) => state.auth);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const { name } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const [dropdownWidth, setDropdownWidth] = useState("auto");
  const dropdownRef = useRef(null);
  const handleLogout = () => {
    navigate("/login");
    dispatch(logout());

    handleToggleDropdown();
  };
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  const handleToggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  useEffect(() => {
    if (dropdownRef.current) {
      const parentWidth = dropdownRef.current.parentElement.offsetWidth;
      setDropdownWidth(`${parentWidth}px`); // Set width based on parent container
    }
  }, [isDropdownOpen]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className=" w80 mx-auto py-3 d-flex align-items-center  justify-content-between ">
      <div
        className="d-flex align-items-center c-pointer "
        onClick={() => navigate("/")}
      >
        <img src={LOGO} style={{ width: "220px", height: "auto" }} alt="" />
      </div>

      <div
        className=" d-flex align-items-center  hide-bar "
        style={{ gap: 50 }}
      >
        <Link
          className={location.pathname === "/" ? "a-active fw-500" : "fw-500"}
          to="/"
        >
          Home
        </Link>

        {token ? (
          <Link
            className={
              location.pathname === "/trips" ? "a-active fw-500" : " fw-500"
            }
            to="/trips"
          >
            Trips
          </Link>
        ) : (
          <></>
        )}
        <Link
          className={
            location.pathname === "/search-list" ? "a-active fw-500" : " fw-500"
          }
          to="/search-list"
          state={{
            open: true,
          }}
          onClick={(e) => {
            if (location.pathname === "/search-list") {
              e.preventDefault();
            }
          }}
        >
          Hotels
        </Link>
        <Link
          className={
            location.pathname === "/explore" ? "a-active fw-500" : " fw-500"
          }
          to="/explore"
        >
          Explore
        </Link>
        {/* <Link to="/search-list">Group Travel</Link> */}
        <Link
          className={
            location.pathname === "/news-room" ? "a-active fw-500" : " fw-500"
          }
          to="/news-room"
        >
          Sevenly Deals
        </Link>
        <Link className={"fw-500"} to="tel:+18667605088">
          <Tooltip title="For Deals Call +1 (866) 760-5088">
            <Button variant="text" startIcon={<CallIcon />}>
              Deals
            </Button>
          </Tooltip>
        </Link>

        {/* <Link
          to="/faq"
          className={
            location.pathname === "/faq" ? "a-active fw-500" : " fw-500"
          }
        >
          Faq
        </Link> */}
      </div>

      <div className="d-flex align-items-center  ">
        <div className="hide-bar">
          {token ? (
            <div style={{ position: "relative" }} ref={dropdownRef}>
              <div
                className="d-flex align-items-center c-pointer"
                style={{ gap: 10 }}
                onClick={handleToggleDropdown}
              >
                <Avatar alt={user || name} src={picture} />
                <p>{user || name}</p>
                {isDropdownOpen ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </div>
              {isDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    zIndex: 99999,
                    width: dropdownWidth,
                  }}
                  className="bxShadow"
                >
                  <ul className="dropdownTopNav">
                    <li
                      onClick={() => {
                        navigate("/user-profile");
                        handleToggleDropdown();
                      }}
                    >
                      User Profile
                    </li>
                    <li onClick={handleLogout}>Logout</li>
                  </ul>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login">Login/SignUp</Link>
          )}
        </div>
        <div className="close-btn">
          <button className="hambutton c-pointer" onClick={toggleDrawer}>
            <MenuIcon />
          </button>
        </div>

        <div className={`side-drawer ${drawerOpen ? "open" : ""}`}>
          <IconButton onClick={toggleDrawer}>
            <Close />
          </IconButton>
          <Link to="/" className="fw-500" onClick={toggleDrawer}>
            Home
          </Link>
          {token ? (
            <Link to="/trips" className="fw-500" onClick={toggleDrawer}>
              Trips
            </Link>
          ) : (
            <></>
          )}
          <Link
            className={
              location.pathname === "/search-list"
                ? "a-active fw-500"
                : " fw-500"
            }
            to="/search-list"
            onClick={(e) => {
              if (location.pathname === "/search-list") {
                e.preventDefault();
              } else {
                toggleDrawer();
              }
            }}
            state={{
              open: true,
            }}
          >
            Hotels
          </Link>

          <Link to="/explore" className="fw-500" onClick={toggleDrawer}>
            Explore
          </Link>
          <Link to="/news-room" className="fw-500" onClick={toggleDrawer}>
            Sevenly Deals
          </Link>
          <Link className={"fw-500"} to="tel:+18667605088">
            <span style={{ color: "#e67e22", fontWeight: "bold" }}>
              For Deals Call
              <br />
              +1 (866) 760-5088
            </span>
          </Link>
          {token ? (
            <>
              <Link
                to="/user-profile"
                onClick={() => {
                  navigate("/user-profile");
                  toggleDrawer();
                }}
                className="fw-500"
              >
                User Porfile
              </Link>

              <Link
                to="/login"
                onClick={() => {
                  handleLogout();
                  toggleDrawer();
                }}
                className="fw-500"
              >
                Logout
              </Link>
            </>
          ) : (
            <Link to="/login" onClick={toggleDrawer} className="fw-500">
              Login/Signup
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopNavBar;
